type ClassValue = string | number | ClassDictionary | ClassArray | undefined | null | boolean;

type ClassDictionary = Record<string, unknown>;

type ClassArray = ClassValue[];

const isArray = (val: ClassValue): val is ClassArray => Array.isArray(val);

const isObject = (val: ClassValue): val is ClassDictionary => {
  return typeof val === 'object' && val !== null && !isArray(val);
};

const isValid = (val: ClassValue): val is string | number => {
  return typeof val === 'string' || typeof val === 'number';
};

export const cx = (...names: ClassValue[]): string => {
  const reduce = (obj: ClassDictionary) => Object.keys(obj)
    .reduce((acc, key) => obj[key] ? acc.concat(key) : acc, [] as string[]);

  return names.reduce<string[]>((acc, arg) => {
    if (!arg) {
      return acc;
    } else if (isValid(arg)) {
      return [ ...acc, String(arg) ];
    } else if (isArray(arg)) {
      return [ ...acc, cx(...arg) ];
    } else if (isObject(arg)) {
      return [ ...acc, ...reduce(arg) ];
    } else {
      return acc;
    }
  }, [])
  .join(' ');
};
